import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['datePicker'];

  connect() {
    import('@xfive/web-components/date-picker');
    import('@xfive/web-components/date-picker.css');
  }

  iconClickHandler(e) {
    const { datePickerTarget: datePicker } = this;

    datePicker.focus();

    // default is prevented if the date picker is already open
    // and it detects a click on the icon and closes the date picker
    // we refocus the date picker but keep it closed
    if (e.defaultPrevented) {
      datePicker.open = false;
    }
  }
}
